class ScheduledEmailResultVM {
    mappingId: number;
    workbookId: number;
    workbookName: string;

    emails: Array<ScheduledEmail>;
    usersGroups: Array<ScheduledEmailUserGroupVM>;
    tabs: Array<ScheduledEmailTabVM>;
    widgets: Array<ScheduledEmailWidgetVM>;
    filters: Array<any>;//Change
    addressLists: Array<AddressList>;
    companies: Array<ScheduledEmailCompanyVM>;
    pdfTemplates: Array<ScheduledEmailPDFTemplateVM>;

    emailsManagement: boolean;
    showEmailLogButton: boolean;
    emailProperties: any;

    dateFormat: any;//??
    startDate: any;//??
    endDate: any;//??
    startTime: any;//??
    endTime: any;//??

    serverDate: any;
}

class ScheduledEmailUserGroupVM {
    id: number;
    name: string;
    type: number;
    typeName: string;
    email: string;
    active: boolean;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.type = data.type;
        this.typeName = data.typeName;
        this.email = data.email;
        this.active = data.active;
    }
}

class ScheduledEmailTabVM {
    id: number;
    name: string;
    type: string;
    reportType: string;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.type = data.type;
        this.reportType = data.reportType;
    }
}

class ScheduledEmailWidgetVM {
    id: number;
    name: string;
    tabId: number;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.tabId = data.tabId;
    }
}

class ScheduledEmailCompanyVM {
    id: number;
    name: string;
    orgId: number;
    users: Array<number>;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.orgId = data.orgId;
        this.users = data.users;
    }
}

//Use the PDFTemplate.ts??
class ScheduledEmailPDFTemplateVM {
    id: number;
    name: string;
    companyId: number;
    organisationId: number;
    mappingId: number;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.companyId = data.companyId;
        this.organisationId = data.organisationId;
        this.mappingId = data.mappingId;
    }

    validCompany(companyId: number) {
        if (irSettings.multiTenant) {
            if (this.organisationId == 0 || this.organisationId === null)
                return true;

            var company = CompanyService.getCompany(companyId);
            if (this.organisationId == company.organisationId && (this.companyId === 0 || this.companyId === null)) {
                return true;
            }

            return this.companyId == companyId;
        }

        return true;
    }

    validMapping(mappingId: number) {
        return this.mappingId === mappingId || this.mappingId === 0;
    }
}